//Login.js
import React from "react";
import { Form, Input, Button, Row, Col, Tooltip, Checkbox, message } from "antd";

import QRCode from 'qrcode.react';
import md5 from "js-md5";
import cookie from "react-cookies";

import Config from "../config/Config";
import Widget from "../widget/Widget";
import WidgetAjax from "../widget/WidgetAjax";
import WidgetModal from "../widget/WidgetModal";
import WidgetAES from '../widget/WidgetAES';

import { EyeTwoTone, EyeInvisibleOutlined } from '@ant-design/icons';
let path = Config.getBasePath();
let application = Config.getApplication();
React.Component.prototype.$md5 = md5;

class forgetPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      stepsData: [
        { name: '验证身份', value: 0 },
        { name: '设置新密码', value: 1 },
        { name: '完成', value: 2 },
      ],
      stepsIndex: 0,
      CELL: undefined,
      countdown: 0,
    };
    this.timer = null;
  }

  componentDidMount() {

  }

  componentWillUnmount() {
    this.clearTimer();
  }

  // 清除定时器
  clearTimer() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  mesCode = (CELL) => {
    const onSend = (res) => {
      if (res.status == 0) {
        // this.setState({ countdown: 120 });
        // this.startCountdown();
      } else {
        message.error("短信发送失败!请重试")
      }
      this.setState({ countdown: 120 });
      this.startCountdown();
    }
    WidgetAjax.ajax({ url: path + '/message/sms', params: { CELL }, callback: onSend });

  }

  handleClick = () => {
    const { CELL } = this.state;
    console.log(CELL, 'CELL----');
    if (CELL && this.validatePhoneNumber(CELL)) {
      if (this.state.countdown === 0) {
        this.mesCode(CELL);
      }
    } else {
      message.error("手机号格式不正确!");
    }
  };

  // 开始倒计时
  startCountdown() {
    this.clearTimer();
    this.timer = setInterval(() => {
      const { countdown } = this.state;
      if (countdown > 0) {
        this.setState(prevState => ({
          countdown: prevState.countdown - 1
        }));
      } else {
        // 倒计时结束，清除定时器
        this.clearTimer();
      }
    }, 1000);
  }

  // 手机号格式校验函数
  validatePhoneNumber = (phone) => {
    // 使用正则表达式校验：11位数字，以1开头
    const regex = /^1\d{10}$/;
    return regex.test(phone);
  };



  next = () => {
    const { stepsIndex, CELL } = this.state;
    this.form.validateFields().then(async (value) => {
      if (stepsIndex == 0) {
        this.setState({ CELL: value?.CELL, stepsIndex: stepsIndex + 1 });
      } else if (stepsIndex == 1) {
        this.reset();
      }
    })
  }

  reset = () => {
    const { CELL, stepsIndex } = this.state;
    this.form.validateFields().then(async (value) => {
      let nonce = Widget.randomString(6, true);
      let newPasswordEncryption = WidgetAES.encryptPassword(value?.newPassword, nonce);
      let params = {
        ...value,
        CELL,
        type: 0,
        new_password: newPasswordEncryption + nonce,
        newPassword: undefined,
        confirmPassword: undefined
      }
      const onReset = async (res) => {
        if (res.status == 0) {
          message.success("修改密码成功!");
          await this.setState({ stepsIndex: stepsIndex + 1 });
          setTimeout(() => {
            this.props.history.push("/login");
          }, 1000);
        } else {
          message.error("修改失败!" + res.message);
        }
      }
      WidgetAjax.ajax({ url: path + '/set_password', params, callback: onReset });
    })
  }


  render() {

    let { stepsData, stepsIndex, CELL, countdown } = this.state;
    let layout = { labelCol: { span: 6 }, wrapperCol: { span: 24 } };
    const buttonText = countdown > 0
      ? `重新获取(${countdown}s)`
      : '免费获取';
    return (
      <div className="retrievePwd">

        <ul>
          {
            stepsData.map((item, index) => {
              return <li className={stepsIndex == index ? 'current' : null} >
                {item?.name}
                {index > 0 ? <span></span> : null}</li>
            })
          }
        </ul>

        <div className="resetPwd">
          <Form ref={ref => this.form = ref} {...layout}>

            {
              stepsIndex == 0 ?
                <Form.Item

                  label="登录手机号"
                  name="CELL"
                  rules={[{
                    required: true,
                    message: '请输入登录手机号'
                  }, {
                    pattern: /^1[3-9]\d{9}$/,
                    message: '请输入正确的手机号格式',
                  }]}
                >
                  <Input placeholder="请输入登录手机号" />
                </Form.Item> : null
            }

            {
              stepsIndex == 1 ?
                <>
                  <Form.Item

                    label="手机号">
                    <Input variant="borderless"  value={CELL.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')} />
                  </Form.Item>
                  <Form.Item
                    label="密码"
                    name="newPassword" hasFeedback rules={[
                      { required: true, message: '请输入登录密码' },
                      { validator: this.validateCreditPassword }
                    ]}
                  >
                    <Input.Password placeholder="请输入登录密码"  />
                  </Form.Item>
                  <Form.Item
                    label="密码确认"
                    name="confirmPassword" dependencies={['newPassword']} hasFeedback
                    rules={[{ required: true, message: '请再次输入密码', },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue('newPassword') === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error('两次输入的密码不一致'));
                      },
                    }),
                    ]}
                  >
                    <Input.Password  placeholder="请再次输入登录密码" iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)} />
                  </Form.Item>
                  <Form.Item style={{ height: '33px', paddingLeft: "6px" }}>
                    <Row gutter={12}>
                      <Col span={16}>
                        <Form.Item
                          label="短信验证码"
                          name="CAPTCHA"
                          rules={[{ required: true, message: '请输入验证码' }]}
                        >
                          <Input placeholder="请输入短信验证" />
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Button style={{ width: "100%",height:'38px'  }} onClick={() => { this.handleClick() }}>{buttonText}</Button>
                      </Col>
                    </Row>
                  </Form.Item>
                </> : null
            }

            {stepsIndex != 2 ? <Button className="next_btn" onClick={() => { this.next() }} >下一步</Button> : null}
          </Form>
        </div>

      </div >
    );
  }
}

export default forgetPassword;
